<template>
  <q-page class="q-pa-md bg-grey-2">
    <div class="row q-col-gutter-md">
      <div class="col-12">
        <q-card class="bg-primary text-white">
          <q-card-section>
            <div class="text-h4">Организации</div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <q-card class="q-pa-md">
      <q-card-section>
        <q-table flat wrap-cells borderless :rows="organisations" :columns="columns" color="primary" row-key="name"
          :pagination="initialPagination" :loading="loading" :filter="filter">
          <template v-slot:top-right>
            <q-input dense debounce="300" v-model="filter" placeholder="Поиск">
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
              <q-th auto-width>
                Статус активности
              </q-th>
            </q-tr>
          </template>

          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.value }}
              </q-td>
              <q-td auto-width>
                {{ props.row.is_active ? "Активна" : "Неактивна" }}
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
      <q-card-section actions>
        <q-btn dense flat label="Обновить организации" @click="onRefreshStatus" />
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import {apiUrl} from "../config";
import axios from "axios";
import {ref} from "vue";

const columns = [
  { name: 'id', label: '№', field: 'id', align: 'left', style: 'width: 44px' },
  { name: 'name', label: 'Наименование', field: 'name', align: 'left', style: 'width: 44px' },
  { name: 'adress', label: 'Адрес', field: 'adress', align: 'left', style: 'width: 44px' },
  { name: 'inn', label: 'ИНН', field: 'inn', align: 'left', style: 'width: 44px' },
  { name: 'workers_count', label: 'Сотрудники', field: 'workers_count', align: 'left', style: 'width: 44px' },
  { name: 'balance', label: 'Баланс', field: 'balance', align: 'left', style: 'width: 44px' },
]

export default {
  name: "organisatons_list",
  mounted() {
    this.emitter.on('onReceiveOrganisationsList', (data) => {
      this.organisations = data;
      this.loading = false;
    })
  },
  data() {
    axios
      .post(apiUrl + '/admin/organisations/list/', {}, {auth: this.$store.state.credentials})
      .then((response) => {
        this.emitter.emit('onReceiveOrganisationsList', response.data);
      })
      .catch((error) => {
        console.log(error)
        this.email = null;
        this.password = null;
      })
    return {
      organisations: ref([]),
      columns: ref(columns),
      loading: ref(true),
      initialPagination: {
        sortBy: 'name',
        descending: true,
        page: 1,
        rowsPerPage: 20
      },
      filter: ref('')
    }
  },
  methods: {
    onRefreshStatus() {
      this.loading = true;
      axios
        .post(apiUrl + '/admin/organisations/list/', {}, { auth: this.$store.state.credentials })
        .then((response) => {
          this.emitter.emit('onReceiveOrganisationsList', response.data);
        })
        .catch((error) => {
          console.log(error)
          this.email = null;
          this.password = null;
        })
    },
  }
}
</script>

<style scoped>

</style>